export default __webpack_public_path__ + "static/media/new-logo-coty-white.ddb087d7.png";